<template>
    <div class="scroll-box" ref="staffScrollbar" v-loading="loading" element-loading-text="拼命加载中">
        <div class="chat-content1">
            <span v-if="total != 0" style="text-align: center" class="ohou">
                <span v-if="showMore">
                    <center style="margin-bottom: 10px; margin-top: 10px;color: #4996F6;font-size: 13px;">
                        向上滚动加载更多
                    </center>
                </span>
                <span v-else>
                    <center style="margin-bottom: 10px; margin-top: 10px;color: #4996F6;font-size: 13px;">
                        无更多记录
                    </center>
                </span>
            </span>
            <div class="chat-complate" v-if="total == 0 && !loading" style="height:100%;">
                <span class="empty-text">{{emptyText}}</span>
            </div>
            <!-- recordContent 聊天记录数组-->
            <div v-for="(itemc, indexc) in data" :key="indexc">
                <!-- 对方 -->
                <div class="word" v-if="!itemc.mineMsg">
                    <div class="time">
                        <div class="nick-name">{{ itemc.nickName }}</div>
                        <span>{{ itemc.timestamp }}</span>
                    </div>
                    <div class="main">
                        <img class="userImage" :src="itemc.headUrl" />
                        <div class="info" style="flex:1;">
                            <div style="display: flex;justify-content: flex-start;align-items: center;height: 100%;">
                                <slot name="left" :row="itemc"></slot>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 我的 -->
                <div class="word-my" v-else>
                    <div class="time">
                        <div class="nick-name">{{ itemc.nickName }}</div>
                        <span>{{ itemc.timestamp }}</span>
                    </div>
                    <div class="main">
                        <div class="info" style="flex:1;">
                            <div style="display: flex;justify-content: flex-end;align-items: center;height:100%;">
                                <slot name="right" :row="itemc"></slot>
                            </div>
                        </div>
                        <span class="userImage">{{ getAvatarName(itemc.nickName) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            default() { return [] }
        },
        total: {
            type: Number,
            default() { return 0 }
        },
        loading: {
            type: Boolean,
            default() { return false }
        },
        showMore: {
            type: Boolean,
            default() { return false }
        },
        size: {
            type: Number,
            default() { return 10 }
        },
        emptyText: {
            type: String,
            default() { return '暂无内容'}
        }
    },
    inject:['showMorePosition','setPosition'],
    mounted() {
        this.handleScroll();
    },
    updated: function () {
        this.scrollDown();
    },
    computed: {
        position: function(){ return this.showMorePosition()}
    },
    methods: {
        getAvatarName(str) {
            let reg = /[\u4e00-\u9fa5]/g
            str = str.match(reg) == null ? '' : str.match(reg).join('')
            let avatorName = ''
            if (str.length > 2) {
                avatorName = str.substring(str.length - 2)
            } else if (str.length != 0) {
                avatorName = str
            } else {
                avatorName = '默认'
            }
            return avatorName
        },
        handleScroll() {
            let scrollbarEl = this.$refs.staffScrollbar;
            scrollbarEl.onscroll = () => {
                if (scrollbarEl.scrollTop == 0) {
                    if (this.showMore) {
                        this.setPosition(this.$refs["staffScrollbar"].scrollHeight);
                        this.$emit('loadMore')
                        
                    }
                }
            };
        },
        scrollDown() {
            // if (this.size == 10) {
            //     this.$refs["staffScrollbar"].wrap.scrollTop =
            //         this.$refs["staffScrollbar"].wrap.scrollHeight;
            // } else {
                this.$refs["staffScrollbar"].scrollTop = this.$refs["staffScrollbar"].scrollHeight - this.position;
            // }
        },
    }
}
</script>
<style lang="scss" scoped>
.scroll-box {
    overflow: hidden;
    overflow-y: scroll;
    position: relative;
    &::-webkit-scrollbar {
        width: 0;
    }
}
.chat-content1 {
    width: 100%;
    height: 60vh;

    .chat-complate {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .empty-text {
            line-height: 60px;
            width: 50%;
            color: #909399;
            text-align: center;
        }
    }

    .ohou {
        text-align: center;
    }

    .word {
        display: flex;
        flex-direction: column;
        padding: 15px 10px;

        .time {
            font-size: 12px;
            color: #9098aa;
            margin: 0;
            display: flex;
            line-height: 20px;
            margin-top: -5px;
            text-align: left;
            margin-left: 52px;
        }

        .main {
            display: flex;

            img {
                margin-left: 10px;
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }

            .info {
                margin-left: 10px;
                flex:1;
                text-align: left;
            }

            .userImage {
                margin: auto 0;
            }
        }
    }

    .word-my {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        padding: 15px 10px;

        img {
            margin-right: 10px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }

        .time {
            text-align: right;
            font-size: 12px;
            color: #9098AA;
            margin: 0;
            display: flex;
            justify-content: flex-end;
            line-height: 20px;
            margin-top: -5px;
            margin-right: 60px;
        }

        .main {
            display: flex;
            justify-content: flex-end;

            .info {
                margin-left: 10px;
                text-align: right;
                flex: 1;

            }

            .userImage {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: rgba(72, 145, 255, 0.2);
                color: #4891FF;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: auto 0;
            }
        }
    }

    .nick-name {
        /* 文本不换行 */
        white-space: nowrap;
        /* 超出范围隐藏 */
        overflow: hidden;
        /* 文字超出用省略号 */
        text-overflow: ellipsis;
        max-width: 11em;
        margin-right: 2px;
    }
}
</style>